import APIconsume from 'Main/APIconsume'

class AuthService {
  constructor () {
    this._apiConsume = new APIconsume()
  }

  /** POST /auth/login: matches the fetch('auth/login') call in login.ejs. */
  async login (email, password) {
    const result = await this._apiConsume.postData({ email, password }, '/auth/login')
    return result?.data
  }

  /** POST /auth/register: matches the fetch('auth/register') call in register.ejs. */
  async register (username, email, password) {
    const result = await this._apiConsume.postData({ username, email, password }, '/auth/register')
    return result?.data
  }
}

export default AuthService